























import {Component, Prop, Vue} from "vue-property-decorator";
@Component({})
export default class TextField extends Vue {
    /*TODO
        md araligi ekle //
     */
    @Prop({required:true}) label!:string;
    @Prop({default:true}) required!:boolean;
    @Prop({default:false}) textarea!:boolean;
    @Prop({}) value!:string;
    @Prop({default:50}) max!:number;
    @Prop({default:1}) min!:number;
    @Prop({default:"12"}) md!:string;
    rules:any = [];
    updateValue (value:string) {
        this.$emit('input', value)
    }
    created(){
        if(this.required === true){
            this.rules.push((v: any) => !!v || 'Zorunlu.');
        }
        //value => (value || '').length <= 20 || 'Max 20 characters',

        if(this.min != null){
            this.rules.push((v: string | any[]) => ((v || '').length >= this.min ) || 'Minimum '+this.min+' karakter')
        }
        if(this.max != null){
            this.rules.push((v: string | any[]) => ((v || '').length  <= this.max) || 'Maximum '+this.max+' karakter')
        }

    }
}
